import GanksterIcon from '@/assets/icons/gankster.svg?react';
import { Button, type ButtonProps } from '@/shared/components/ui/button';
import { cn } from '@/shared/utils/cn';

export interface PageHeaderGanksterProps extends Omit<ButtonProps, 'children'> {
  className?: string;
}

export const PageHeaderGankster = (props: PageHeaderGanksterProps) => {
  const { className, ...rest } = props;

  return (
    <Button {...rest} variant="ghost" className={cn('px-0', className)}>
      <GanksterIcon className="text-cold-50 size-6" />
    </Button>
  );
};
